<template lang="html">
  <div class="encounter-preview-box row">
    <div v-if="encounter && encounter.encounter_type && encounter.encounter_type=='tpPresentation'" class="col-8 encounter-type d-flex align-items-center">
      <i class="encounter-type-icon fal fa-3x fa-file-invoice-dollar"></i>
      <div class="encounter-type-text">
        <h4><strong>Treatment Plan <br>Presentation</strong></h4>
      </div>
    </div>
    <div v-if="!encounter || !encounter.encounter_type" class="col-8 encounter-type d-flex align-items-center">
      <i class="encounter-type-icon fal fa-3x fa-clipboard-user"></i>
      <div class="encounter-type-text">
        <h4><strong>Appointment</strong></h4>
      </div>
    </div>
    <div v-if="appointment" class="col-4 appointment-details">
      <p class="appointment-time"><strong>{{ appointment.AptDateTime | prettyTimeFromDT }}</strong></p>
      <p v-if="appointment.PatientName" class="snug">
        <span class="pt-name-label">Patient Name</span><br>
        <span class="pt-name">{{ appointment.PatientName }}</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: ['appointment','encounter'],
  data() {
    return {
      checklistComplete: false,
    };
  },
  watch: {
    
  },
  methods: {
    
  },
}
</script>

<style lang="less" scoped>
@import "../assets/less/variables.less";

.encounter-preview-box {
  margin: 0 0 20px;

  .encounter-type,
  .appointment-details {
    border: 1px solid @dark-color;
    padding: 20px
  }
  .encounter-type {
    .encounter-type-text {
      margin-left: 10px;
    }
    h4 {
      margin: 0;
      line-height: 1em;
    }
  }
  .appointment-details {
    border-left: none;;
  }
}
.pt-name-label {
  text-transform: uppercase;
  font-size: 12px;
  line-height: 1em;
  font-weight: 400;
}
.pt-name {
  font-size: 18px;
  line-height: 1em;
  font-weight: 400;
}
.appointment-time {
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 15px
}
</style>
